
import React from "react";

interface UploadProgressProps {
  isSubmitting: boolean;
  progress: number;
}

const UploadProgress: React.FC<UploadProgressProps> = ({ isSubmitting, progress }) => {
  if (!isSubmitting || progress <= 0) return null;
  
  return (
    <div className="w-full bg-gray-200 rounded-full h-2.5 dark:bg-gray-700 mt-4">
      <div 
        className="bg-primary h-2.5 rounded-full" 
        style={{ width: `${progress}%` }}
      ></div>
    </div>
  );
};

export default UploadProgress;
